// extracted by mini-css-extract-plugin
export default {"Input2DFunction":"Input2DFunction_Input2DFunction__oNvjo","FunctionInputs":"Input2DFunction_FunctionInputs__-C8Pv","FunctionDisplay":"Input2DFunction_FunctionDisplay__QGRtH"};